import React, { useEffect } from 'react';
import { useOutletContext } from "react-router-dom";

import Feature4 from './Feature4';
import Teams1 from './Teams1';
// import Feature6 from './Feature6';
import Feature7 from './Feature7';
import Content9 from './Content9';
import Content5 from './Content5';
// import Plan from './Plan';

import {
  Feature40DataSource,
  Teams10DataSource,
  Feature60DataSource,
  Feature70DataSource,
  Content90DataSource,
  // PlanDataSource,
  Content50DataSource,
} from './data.source';
import './less/index.less';
import { Helmet } from 'react-helmet';

export default function About() {

  const { isMobile, onEnterChange } = useOutletContext();

  useEffect(() => {
    onEnterChange(false);
  }, []);

  const children = [
    <Feature4
      id="Feature4_0"
      key="Feature4_0"
      dataSource={Feature40DataSource}
      isMobile={isMobile}
    />,
    <Teams1
      id="Teams1_0"
      key="Teams1_0"
      dataSource={Teams10DataSource}
      isMobile={isMobile}
    />,
    <Feature7
      id="Feature7_0"
      key="Feature7_0"
      dataSource={Feature70DataSource}
      isMobile={isMobile}
    />,
    <Content9
      id="Content9_0"
      key="Content9_0"
      dataSource={Content90DataSource}
      isMobile={isMobile}
    />,
    // <Feature6
    //   id="Feature6_0"
    //   key="Feature6_0"
    //   dataSource={Feature60DataSource}
    //   isMobile={isMobile}
    // />,
    <Content5
      id="Content5_0"
      key="Content5_0"
      dataSource={Content50DataSource}
      contentDataSource={Feature60DataSource}
      isMobile={isMobile}
      isAll={true}
    />,
    // <Plan
    //   id="Plan_0"
    //   key="Plan_0"
    //   dataSource={PlanDataSource}
    //   isMobile={isMobile}
    // />
  ];
  return (
    <div
      className="templates-wrapper"
    ><Helmet>
      <meta charSet="utf-8" />
      <title>爱瑟福信息科技(上海)有限公司-关于爱瑟福</title>
    </Helmet>
      {children}
    </div>
  );
}
